import React from "react";
import glamorous from "glamorous";
import moment from "moment";

const SmallerTextDiv = glamorous.div({
  fontSize: "smaller"
});

const BoldSmallerTextDiv = glamorous(SmallerTextDiv)({
  fontWeight: "bold"
});

export const getArrivalWindowText = loc => {
  const empty = { windowTimeText: "N/A", windowDateText: null };
  if (!loc || !(loc.earliest_arrival_datetime || loc.latest_arrival_datetime)) {
    return empty;
  }

  const earliestArrival = moment.utc(loc.earliest_arrival_datetime);
  const latestArrival = moment.utc(loc.latest_arrival_datetime);

  const latestText = {
    windowTimeText: latestArrival.local().format("HH:mm"),
    windowDateText: latestArrival.local().format("l")
  };

  if (loc.earliest_arrival_datetime && loc.latest_arrival_datetime) {
    // often they are the same
    if (loc.earliest_arrival_datetime === loc.latest_arrival_datetime) {
      return latestText;
    }

    return {
      windowTimeText: `${earliestArrival
        .local()
        .format("HH:mm")} to ${latestArrival.local().format("HH:mm")}`,
      windowDateText: earliestArrival.local().format("l")
    };
  }

  if (loc.latest_arrival_datetime) {
    return latestText;
  }
  if (loc.earliest_arrival_datetime) {
    return {
      windowTimeText: earliestArrival.local().format("HH:mm"),
      windowDateText: earliestArrival.local().format("l")
    };
  }
  console.error("shouldn't get here!");
  return empty;
};

export const ScheduledArrivalWindow = ({ loc }) => {
  const { windowTimeText, windowDateText } = getArrivalWindowText(loc);
  return (
    <React.Fragment>
      <BoldSmallerTextDiv css={{ fontWeight: "bold" }}>
        {windowTimeText}
      </BoldSmallerTextDiv>
      <SmallerTextDiv>{windowDateText}</SmallerTextDiv>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/modules/shipment-detail/ArrivalWindow.js